module.exports = __webpack_public_path__ + "static/media/orderDetailsExpectedForIcon.8fdbf4f3.svg";